import { LitElement, html, css } from "lit-element";

// language=CSS
export const ButtonOutlinedStyle = css`
	.button-outlined {
		display: inline-block;
		margin: 15px 0 5px;

		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Safari */
		-khtml-user-select: none; /* Konqueror HTML */
		-moz-user-select: none; /* Firefox */
		-ms-user-select: none; /* Internet Explorer/Edge */
		user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
	}

	.button-outlined[no-margin] {
		margin: 0;
	}

	.button-outlined > * {
		display: inline-block;
		box-sizing: border-box;
		border: 2px solid var(--app-accent, black);
		background-color: transparent;
		font-size: 14px;
		font-weight: 500;

		cursor: pointer;
		color: var(--app-accent, black);
		margin: 0;
		padding: 8px 16px;
		text-align: center;
		text-decoration: none;
		text-transform: uppercase;
		border-radius: 3px;
		outline: none;
		-webkit-appearance: none;
		transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
	}

	.button-outlined[lowecase] > * {
		text-transform: lowercase;
	}

	.button-outlined label {
		cursor: pointer;
	}

	.button-outlined[rounded] > * {
		border-radius: 24px;
	}

	.button-outlined[strong] > * {
		font-weight: bold;
	}

	.button-outlined[small] > * {
		padding: 8px;
		border: 1px solid var(--app-accent);
	}

	.button-outlined > *:focus {
	}

	.button-outlined > *:active {
		opacity: 0.87;
		color: #fff;
	}

	.button-outlined[app-red] > * {
		border: 1px solid var(--app-red);
		background-color: transparent;
	}

	.button-outlined[white] > * {
		border: 1px solid #ffffff;
		background-color: transparent;
	}

	.button-outlined > *[disabled] {
		background-color: grey;
		border-color: grey;
	}

	@media (max-width: 767px) {
		/* Responsive buttons are used in shop-detail, shop-cart and shop-checkout */
		.button-outlined[responsive] {
			height: 64px;
			z-index: 1;
		}

		.button-outlined[responsive] > * {
			background-color: var(--app-accent);
			border: none;
			color: white;
			padding: 20px;
			width: 100%;
			height: 100%;
			font-size: 15px;
		}

		.button-outlined[responsive] > *:focus {
			background-color: var(--app-accent);
		}
	}
`;

// language=CSS
const ButtonOutlinedStyleHost = css`
    :host {
        display: inline-block;
        margin: 15px 0 5px;

        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }

    :host[no-margin] {
        margin: 0;
    }

	:host > a,
	:host > button {
        display: inline-block;
        box-sizing: border-box;
        border: 2px solid var(--sw-button-outlined-color, var(--app-accent, black));
        background-color: transparent;
        font-size: 14px;
        font-weight: 500;

        cursor: pointer;
        color: var(--sw-button-outlined-color, var(--app-accent, black));
        margin: 0;
        padding: var(--sw-button-outlined-padding, 8px 16px);
        text-align: center;
        text-decoration: none;
        text-transform: uppercase;
        border-radius: var(--sw-button-outlined-border-radius, 3px);
        outline: none;
        -webkit-appearance: none;
        transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
    }


    :host label {
        cursor: pointer;
    }

	:host > a:active,
	:host > button:active {
        opacity: 0.87;
        color: #FFF;
        background-color: var(--sw-button-outlined-color, var(--app-accent, black));
    }

	:host > a:active slot,
	:host > button:active slot {
        --sw-icon-color: #FFFFFF;
    }
    
    :host[app-red] > button {
        border: 1px solid var(--app-red);
        background-color: transparent;
    }

    :host[white] > button {
        border: 1px solid #FFFFFF;
        background-color: transparent;
    }

    :host > button[disabled] {
        background-color: grey;
        border-color: grey;
    }

    @media (max-width: 767px) {
        /* Responsive buttons are used in shop-detail, shop-cart and shop-checkout */
        :host[responsive] {
            height: 64px;
            z-index: 1;
        }

        :host[responsive] > button {
            background-color: var(--app-accent);
            border: none;
            color: white;
            padding: 20px;
            width: 100%;
            height: 100%;
            font-size: 15px;
        }

        :host[responsive] > button:focus {
            background-color: var(--app-accent);
        }

    }
`;

export class ButtonOutlined extends LitElement {
	static get styles() {
		return ButtonOutlinedStyleHost;
	}

	static get properties() {
		return {
			label: { type: String },
			href: { type: String }
		};
	}

	render() {
		return html`
			${this.href
				? html`
						<a href="${this.href}"><slot></slot>${this.label}</a>
				  `
				: html`
						<button><slot></slot>${this.label}</button>
				  `}
		`;
	}
}

customElements.define("button-outlined", ButtonOutlined);
